/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import Header3 from '../components/header/header-rslhome';
import Footer3 from '../components/footer/footer-3';
import { useRouter } from 'next/router';
import DetailsContent from '../components/blog/blog-details/DataTermsPolicy';
import { policyList, termsList } from '../redux/slices/product';
import { useDispatch, useSelector } from 'react-redux';
import Seo from '../components/common/Seo';
import { Skeleton } from '@mui/material';
import { fetchSeoByPage } from '../lib/seoHelper';

const TermsUrl = ({ meta }) => {
  const router = useRouter();
  const { termsListRes } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  const [terms, setTerms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Terms List api

  useEffect(() => {
    dispatch(termsList()).then(() => {
      // Use setTimeout to delay hiding the loader
      setTimeout(() => setIsLoading(false), 1000); // Adjust the delay time as needed
    });
  }, [dispatch]);

  useEffect(() => {
    if (termsListRes) {
      setTerms(termsListRes);
    }
  }, [termsListRes]);



  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />
      <div className="careers-main mt-careers-main">
        <div className="rule"></div>
        <div className="container">
          <div className="careers-content">
            <h3 className="text-center mb-10">Terms And Policy</h3>
            {/* {terms.map((item,index)=>
                 <DetailsContent terms={item?.terms} />
                )} */}
            {isLoading ? (
              <div>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((line) => (
                  <Skeleton
                    key={line}
                    // animation="wave"
                    variant="text"
                    width={'100%'}
                    height={50}
                  />
                ))}
              </div>
            ) : (
              terms.map((item, index) => (
                <DetailsContent terms={item?.terms} key={index} />
              ))
            )}
          </div>
        </div>
      </div>
      <Footer3 />
    </>
  );
};

export default TermsUrl;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}